import { t } from "../services/utils";
export default {
  BREAKFAST: 1,
  LUNCH: 2,
  DINNER: 3,
  SNACKS: 4
};